import { FC, memo } from 'react'

import { Button, Stack, useTheme } from '@mui/material'

import { useTranslation } from 'react-i18next'

import Icon from 'src/@core/components/icon'
import { CustomTextField } from 'src/@core/components/mui/text-field'

import CustomSelect, { CustomSelectOption } from 'src/components/common/select/CustomSelect'

import { FileSort } from '../../../../pages/courses/media-storage'

const fileSortOptions: CustomSelectOption[] = [
  {
    name: 'sort.a-z',
    value: 'a-z'
  },
  {
    name: 'sort.z-a',
    value: 'z-a'
  },
  {
    name: 'sort.newest',
    value: 'newest'
  },
  {
    name: 'sort.oldest',
    value: 'oldest'
  },
  {
    name: 'sort.smallest',
    value: 'smallest'
  },
  {
    name: 'sort.largest',
    value: 'largest'
  }
]

interface MentorCloudSearchBarProps {
  view: 'grid' | 'list'
  onChangeView: (view: 'grid' | 'list') => void
  sort: FileSort
  onChangeSort: (sort: FileSort) => void
  search: string
  onChangeSearch: (search: string) => void
}

export const MentorCloudSearchBar: FC<MentorCloudSearchBarProps> = memo(props => {
  const { view, onChangeView, sort, onChangeSort, search, onChangeSearch } = props

  const { t } = useTranslation('translation', { keyPrefix: 'PAGE.MENTORCLOUD' })
  const theme = useTheme()

  return (
    <Stack gap={theme.spacing(3)} sx={{ flexDirection: { xs: 'column', md: 'row' } }}>
      <CustomTextField
        placeholder={t('placeholder.search')}
        value={search}
        onChange={e => onChangeSearch(e.target.value)}
        InputProps={{
          endAdornment: <Icon icon='tabler:search' />
        }}
        fullWidth
      />
      <CustomSelect
        variant='outlined'
        handleValueChange={e => onChangeSort(e.target.value as FileSort)}
        selectItems={fileSortOptions.map(option => ({ ...option, name: t(option.name) }))}
        value={sort}
      />
      <Button
        sx={{ padding: theme.spacing(0.5) }}
        onClick={() => onChangeView(view === 'grid' ? 'list' : 'grid')}
        color='primary'
      >
        <Icon
          icon='tabler:list'
          fontSize={theme.spacing(5.25)}
          style={{
            position: 'absolute',
            transform: `scale(${view === 'list' ? 1 : 0})`,
            transition: 'all .2s ease-in-out'
          }}
        />
        <Icon
          icon='tabler:layout-grid'
          fontSize={theme.spacing(5.25)}
          style={{
            position: 'absolute',
            transform: `scale(${view === 'grid' ? 1 : 0})`,
            transition: 'all .2s ease-in-out'
          }}
        />
      </Button>
    </Stack>
  )
})
